// CountryPicker — Phase 5 country dropdown used at Step 1 of New Deal wizard
// and in Settings (default country preference).
//
// Reads the country list from GET /api/tax-rules so we never duplicate the
// supported-countries set on the client.

import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

let countryCache = null;

export function useCountryList() {
  const [countries, setCountries] = useState(countryCache?.countries || null);
  useEffect(() => {
    if (countryCache) return;
    api
      .get("/tax-rules")
      .then(({ data }) => {
        countryCache = data;
        setCountries(data.countries);
      })
      .catch(() => {
        setCountries([]);
      });
  }, []);
  return countries || [];
}

export default function CountryPicker({ value, onChange, disabled, "data-testid": testid }) {
  const countries = useCountryList();
  return (
    <Select value={value || "US"} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid={testid || "country-picker"}>
        <SelectValue placeholder="Select country" />
      </SelectTrigger>
      <SelectContent>
        {countries.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`country-option-${c.code}`}>
            {c.name} ({c.currency})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function StatePicker({ country, value, onChange, disabled }) {
  const countries = useCountryList();
  const meta = countries.find((c) => c.code === country);
  const states = meta?.states || [];
  if (!states.length) return null;
  return (
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger data-testid="state-picker">
        <SelectValue placeholder="State / Province (optional)" />
      </SelectTrigger>
      <SelectContent>
        {states.map((s) => (
          <SelectItem key={s} value={s} data-testid={`state-option-${s}`}>
            {s}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
